import React, { ReactNode } from "react";
import { useResponsive } from "@/hooks/useResponsive";
import { MobileBottomNav } from "./MobileBottomNav";
import { AuthenticatedMobileNavbar } from "./AuthenticatedMobileNavbar";
import { useAtom } from "jotai";
import { showBottomNavAtom } from "@/stores/ui.atom";

interface ResponsiveLayoutProps {
  children: ReactNode;
  showBottomNav?: boolean;
  showNavbar?: boolean;
  backgroundColor?: string;
  className?: string;
  fullHeight?: boolean;
  centered?: boolean;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | "full";
}

/**
 * Component layout responsive thay thế cho AuthenticatedLayout
 */
export const ResponsiveLayout: React.FC<ResponsiveLayoutProps> = ({
  children,
  showBottomNav = true,
  showNavbar = true,
  backgroundColor = "#FBF6F1",
  className = "",
  fullHeight = false,
  centered = false,
  maxWidth = "full",
}) => {
  const {
    isIphoneSE,
    isIphoneXR,
    isIphone12,
    isIphone14ProMax,
    isSamsungGalaxy,
  } = useResponsive();
  const [showBottomNavGlobal] = useAtom(showBottomNavAtom);

  // Tính toán padding dựa trên loại thiết bị
  const getPadding = () => {
    // Điều chỉnh padding cho các thiết bị nhỏ
    if (isIphoneSE || isSamsungGalaxy) {
      return "px-3 pb-3";
    }

    // Điều chỉnh padding cho các thiết bị trung bình
    if (isIphone12 || isIphoneXR) {
      return "px-4 pb-4";
    }

    // Điều chỉnh padding cho các thiết bị lớn
    if (isIphone14ProMax) {
      return "px-5 pb-5";
    }

    // Padding mặc định
    return "px-4 pb-4";
  };

  // Tính toán max width
  const getMaxWidth = () => {
    switch (maxWidth) {
      case "xs":
        return "max-w-xs";
      case "sm":
        return "max-w-sm";
      case "md":
        return "max-w-md";
      case "lg":
        return "max-w-lg";
      case "xl":
        return "max-w-xl";
      case "full":
        return "max-w-full";
      default:
        return "max-w-md";
    }
  };

  // Tính toán height
  const getHeight = () => {
    return fullHeight ? "min-h-screen" : "";
  };

  // Tính toán centering
  const getCentering = () => {
    return centered ? "mx-auto" : "";
  };

  // Tính toán bottom padding cho bottom nav
  const getBottomPadding = () => {
    return showBottomNav ? "pb-[75px]" : "";
  };

  return (
    <div
      className={`
        responsive-layout
        ${getHeight()}
        ${getPadding()}
        ${className}
      `}
      style={{ backgroundColor }}
    >
      <div
        className={`
        w-full 
        flex flex-col 
        ${getMaxWidth()} 
        ${getCentering()}
        ${getHeight()}
      `}
      >
        {showNavbar && <AuthenticatedMobileNavbar />}
        <div className={`flex-1 ${getBottomPadding()}`}>{children}</div>
        {showBottomNav && showBottomNavGlobal && <MobileBottomNav />}
      </div>
    </div>
  );
};
